import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Eye, ShieldCheck, HeartPulse, Sparkles } from 'lucide-react';
const benefits = [{
  icon: <Eye className="w-8 h-8 text-amber" data-id="element-18" />,
  title: 'Control Total',
  description: 'Sabes exactamente qué aplicas en tu piel, sin ingredientes ocultos ni nombres impronunciables.'
}, {
  icon: <ShieldCheck className="w-8 h-8 text-amber" data-id="element-19" />,
  title: 'Sin Químicos',
  description: 'Libre de conservantes, parabenos y fragancias artificiales que causan alergias.'
}, {
  icon: <HeartPulse className="w-8 h-8 text-amber" data-id="element-20" />,
  title: 'Propiedades Reales',
  description: 'Aprovecha el poder de plantas con beneficios comprobados por generaciones.'
}, {
  icon: <Sparkles className="w-8 h-8 text-amber" data-id="element-21" />,
  title: 'Fácil y Económico',
  description: 'Ingredientes accesibles y una preparación simple que te ahorrará dinero a largo plazo.'
}];
export function Benefits() {
  return <SectionWrapper id="beneficios" className="px-4 md:px-12 max-w-6xl mx-auto bg-sage/5 rounded-3xl py-16 my-12" data-id="element-22">
      <div className="text-center mb-12" data-id="element-23">
        <h2 className="text-3xl md:text-5xl font-playfair text-forest mb-4" data-id="element-24">
          ¿Por qué elegir pomadas naturales?
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 md:gap-8 px-4 md:px-8" data-id="element-25">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-card rounded-2xl p-8 shadow-warm border border-sage/10 hover:border-sage/30 transition-colors group" data-id="element-26">
            <div className="w-16 h-16 rounded-full bg-amber/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-27">
              {benefit.icon}
            </div>
            <h3 className="text-2xl font-playfair text-forest mb-3" data-id="element-28">
              {benefit.title}
            </h3>
            <p className="text-brown/80 leading-relaxed text-lg" data-id="element-29">
              {benefit.description}
            </p>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}